import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/museum/rectangle_mobile.png'
import _imports_1 from '@/assets/images/museum/rectangle_desktop.png'


const _withScopeId = n => (_pushScopeId("data-v-dbdac182"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "GetTicket" }
const _hoisted_2 = { class: "Shadow" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_5 = { class: "Inner" }
const _hoisted_6 = { class: "Header" }
const _hoisted_7 = { class: "Title" }
const _hoisted_8 = { class: "Exhibition__Cta" }
const _hoisted_9 = ["href"]

import { gsap } from 'gsap'
import { VARIANT as UIBtnVariant, THEME as UIBtnTheme } from '@/components/UIBtn/UIBtnPrimary.vue'

import { useSelector } from '@xstate/vue'
import Viewport from '@/store/modules/Viewport'


import { computed, defineComponent, onMounted, ref, ComponentPublicInstance, watch, nextTick } from 'vue'

const __default__ = defineComponent({
})

function setup(__props) {

const isMobile = computed(() => !Viewport.isDesktop)


return (_ctx: any,_cache: any) => {
  const _component_heading = _resolveComponent("heading")!
  const _component_ui_btn = _resolveComponent("ui-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(isMobile))
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : (_openBlock(), _createElementBlock("img", _hoisted_4))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          ref: (_value, _refs) => {
            _refs['subtitle'] = _value
          },
          class: "Subtitle small-caps"
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('tickets.date')), 1)
        ], 512),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_heading, {
            text: _ctx.$t('tickets.title')
          }, null, 8, ["text"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_ui_btn, {
            variant: _unref(UIBtnVariant).OUTLINE,
            theme: _unref(UIBtnTheme).DARK
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                href: _ctx.$t('about.exhibition_ticket_link'),
                target: "_blank"
              }, _toDisplayString(_ctx.$t('about.exhibition_cta')), 9, _hoisted_9)
            ]),
            _: 1
          }, 8, ["variant", "theme"])
        ])
      ])
    ])
  ]))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup})